import { SignJWT, jwtVerify } from 'jose';

const SECRET_KEY = 'da2-lr32duwbcrcmxozkrqyvpmsgg4';
const ALGORITHM = 'HS256';
const secret = new TextEncoder().encode(SECRET_KEY);

// Signs a JWT with HS256. No iat timestamp added (matches original noTimestamp:true behaviour).
export const generate = (payload) => new SignJWT(payload).setProtectedHeader({ alg: ALGORITHM }).sign(secret);

// Verifies a JWT and resolves with the decoded payload.
export const validate = (token) => jwtVerify(token, secret).then(({ payload }) => payload);
